export const NAMESPACE = 'hris';
